import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "use", "render"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { DuplicatePlaylistModalTrigger } from './DuplicatePlaylistModalTrigger';
import { jsx as _jsx } from "react/jsx-runtime";
export const DuplicatePlaylistButton = _ref => {
  let {
      playlistId,
      use,
      render
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(DuplicatePlaylistModalTrigger, {
    playlistId: playlistId,
    renderTrigger: ({
      openModal
    }) => {
      const handleClick = () => {
        UsageTracker.trackStandalone('Playlist Interaction', {
          action: 'duplicate-playlist-click',
          playlistId
        });
        openModal();
      };
      if (render) {
        return render(handleClick);
      }
      return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
        onClick: handleClick,
        use: use,
        children: /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.playlists.duplicatePlaylist"
          })
        })
      }));
    }
  });
};